// Shared RCS UI treatment so the line-selector badges stay consistent.
// Green mirrors the RCS treatment used on the api-core admin side.
export const RCS_COLOR = '#00a344'
export const RCS_LABEL = 'RCS'

// RCS counts a message in UTF-8 bytes, not in GSM-7 / UCS-2 characters, and bills a text message
// in flat 160-byte segments — there are no multi-segment headers eating into the segment and no
// collapse to 70 characters when the body carries an emoji, both of which SMS has.
// @see https://www.twilio.com/en-us/blog/developers/rcs-character-count
export const RCS_SEGMENT_BYTES = 160
